import React from 'react';
import { Tooltip } from 'src/common';
import styled from 'styled-components';
import {
  ExecutiveSummaryItem,
  RiskToleranceItem,
  SandboxItem,
  ScenarioWizardItem,
  SnapshotsItem,
  SuggestionsItem,
  AssessmentVariablesItem,
  EventActionItem,
} from './comps';

const Div = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 4px 22px;
  flex-wrap: wrap;
  justify-content: flex-end;

  .readonly {
    cursor: default;
    * {
      cursor: default;
    }
    svg {
      path {
        fill: ${({ theme }) => theme.colors.cflowerBlue};
      }
    }
  }
`;

type QuickActionType =
  | 'EXECUTIVE_SUMMARY'
  | 'RISK_TOLERANCE'
  | 'SCENARIO_WIZARD'
  | 'ASSESSMENT_VARIABLES'
  | 'SUGGESTIONS'
  | 'SNAPSHOTS'
  | 'SANDBOX'
  | 'EVENT_ACTION';

interface QuickActionsMenuProps {
  actions: {
    type: QuickActionType;
    onClick: () => void;
    disabled?: boolean;
    readonly?: boolean;
    tooltip?: string;
    itemProps?: any;
  }[];
}

const item: Record<QuickActionType, (props: any) => React.ReactNode> = {
  EXECUTIVE_SUMMARY: (props) => <ExecutiveSummaryItem {...props} />,
  RISK_TOLERANCE: (props) => <RiskToleranceItem {...props} />,
  SCENARIO_WIZARD: (props) => <ScenarioWizardItem {...props} />,
  ASSESSMENT_VARIABLES: (props) => <AssessmentVariablesItem {...props} />,
  SUGGESTIONS: (props) => <SuggestionsItem {...props} />,
  SNAPSHOTS: (props) => <SnapshotsItem {...props} />,
  SANDBOX: (props) => <SandboxItem {...props} />,
  EVENT_ACTION: (props) => <EventActionItem {...props} />,
};

const QuickActionsMenu: React.FC<QuickActionsMenuProps> = ({ actions }) => {
  return (
    <Div>
      {actions
        .filter((el) => !el.disabled)
        .map((el) => (
          <Tooltip
            key={el.type}
            dataId={`op-${el.type}`}
            dataHtml={el.tooltip || ''}
            place="top"
            data-tooltip-id={`op-${el.type}`}
          >
            <div
              key={el.type}
              className={`qa-item ${el.readonly ? 'readonly' : ''}`}
              onClick={el.readonly ? undefined : el.onClick}
            >
              {item[el.type]({ ...el.itemProps, readonly: el.readonly })}
            </div>
          </Tooltip>
        ))}
    </Div>
  );
};

export default QuickActionsMenu;
